import Form from 'react-bootstrap/Form';
import useTranslation from "../hooks/translations";

export default function SelectField({
                                      name,
                                      label,
                                      placeholder,
                                      options,
                                      selectedOption,
                                      handleChange,
                                      error,
                                      fieldRef
                                    }) {
  const translations = useTranslation();
  const placeholderText = placeholder ? placeholder : translations.selectPlaceholder;
  return (
    <Form.Group controlId={name} className="SelectField">
      {label && <Form.Label className="small mb-1">{label}</Form.Label>}
      <Form.Select ref={fieldRef}
                   options={options}
                   value={selectedOption}
                   onChange={handleChange}>
        <option value="">{placeholderText}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>{option.name}</option>
        ))}
      </Form.Select>
      <Form.Text className="text-danger">{error}</Form.Text>
    </Form.Group>
  )
}
